var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-imaging.9ade0179.png","uri@2x": __webpack_public_path__ + "icon-imaging.2cdd52ae.png","uri@3x": __webpack_public_path__ + "icon-imaging.a878988b.png",
    width: 20,
    height: 20
});